import { templateEditorLogger } from '../logger.instance';
import type { ContentStatement } from './ast-node.model';

const logger = templateEditorLogger.extend('content-statement');

/**
 * Implementação do nó `ContentStatement` da AST.
 * Representa um trecho de texto puro no template.
 */
export class ContentStatementNode implements ContentStatement {
  public readonly type = 'ContentStatement';

  /**
   * @param value O conteúdo de texto do nó.
   */
  public constructor(public value: string) {}

  /**
   * Converte o nó de volta para sua representação em string.
   * Substitui `&nbsp;` (non-breaking spaces), frequentemente inseridos por `contenteditable`,
   * por espaços normais para uma saída de template limpa.
   *
   * @returns A string de texto limpa.
   */
  public toString(): string {
    // Substitui non-breaking spaces por espaços normais para uma saída limpa.
    return this.value.replaceAll('\u00A0', ' ');
  }

  /**
   * Método estático para parsear um nó do DOM e criar uma instância de `ContentStatementNode`.
   *
   * @param node O nó do DOM a ser analisado.
   * @returns Uma nova instância de `ContentStatementNode` se o nó for um nó de texto com conteúdo,
   *          caso contrário, `null`.
   */
  public static parse(node: Node): ContentStatementNode | null {
    logger.debug('Parsing node', node);
    if (node.nodeType === Node.TEXT_NODE && node.textContent) {
      return new ContentStatementNode(node.textContent);
    }

    return null;
  }
}
